import { __extends } from "tslib";
import { IgrAxis } from "./igr-axis";
import { IgrAnnotationLayer } from "./igr-annotation-layer";
import { CategoryToolTipLayer } from "./CategoryToolTipLayer";
import { ensureBool } from "igniteui-react-core";
/**
 * Represents an annotation layer that displays grouped tooltips for series that use a category axis.
*/
var IgrCategoryToolTipLayer = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(IgrCategoryToolTipLayer, _super);
    function IgrCategoryToolTipLayer(props) {
        return _super.call(this, props) || this;
    }
    IgrCategoryToolTipLayer.prototype.createImplementation = function () {
        return new CategoryToolTipLayer();
    };
    Object.defineProperty(IgrCategoryToolTipLayer.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCategoryToolTipLayer.prototype, "isAnnotationHoverLayer", {
        /**
         * Gets whether the series is an annotation layer displayed only when hovering over the chart.
        */
        get: function () {
            return this.i.db;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCategoryToolTipLayer.prototype, "isDefaultTooltipBehaviorDisabled", {
        /**
         * Gets whether the default tooltip behaviors for the chart are disabled if this layer is present.
        */
        get: function () {
            return this.i.dl;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCategoryToolTipLayer.prototype, "targetAxis", {
        /**
         * Gets or sets the Axis to target this annotation to. If null, this annotation layer will not render content.
        */
        get: function () {
            var r = this.i.rc;
            if (r == null) {
                return null;
            }
            if (!r.externalObject) {
                var e = IgrAxis._createFromInternal(r);
                if (e) {
                    e._implementation = r;
                }
                r.externalObject = e;
            }
            return r.externalObject;
        },
        set: function (v) {
            if (v != null && this._stylingContainer && v._styling)
                v._styling(this._stylingContainer, this, this);
            v == null ? this.i.rc = null : this.i.rc = v.i;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCategoryToolTipLayer.prototype, "useInterpolation", {
        /**
         * Gets or sets whether to use value interpolation when drawing the tooltips.
        */
        get: function () {
            return this.i.rg;
        },
        set: function (v) {
            this.i.rg = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    IgrCategoryToolTipLayer.prototype.findByName = function (name) {
        var baseResult = _super.prototype.findByName.call(this, name);
        if (baseResult) {
            return baseResult;
        }
        if (this.targetAxis && this.targetAxis.name && this.targetAxis.name == name) {
            return this.targetAxis;
        }
        return null;
    };
    IgrCategoryToolTipLayer.prototype._styling = function (container, component, parent) {
        _super.prototype._styling.call(this, container, component, parent);
        this._inStyling = true;
        if (this.targetAxis && this.targetAxis._styling) {
            this.targetAxis._styling(container, component, this);
        }
        this._inStyling = false;
    };
    /**
     * Hides any tooltips presented by the layer, if any.
    
    */
    IgrCategoryToolTipLayer.prototype.hideToolTips = function () {
        this.i.lg();
    };
    return IgrCategoryToolTipLayer;
}(IgrAnnotationLayer));
export { IgrCategoryToolTipLayer };
